<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <CWrapper class="justify-content-between">
      <main class="">
        <!-- c-main -->
        <CContainer fluid style="padding: 0px">
          <transition name="fade">
            <CRow :gutters="false">
              <CCol
                md="12"
                lg="7"
                :xl="currentRouteName == 'terms-and-conditions-login' || currentRouteName == 'privacy-policy-login' ? '12' : '5'"
                class="min-vh-100"
              >
                <CRow class="h-100">
                  <CCol
                    :sm="{ size: 10, offset: 1 }"
                    :md="{ size: 11, offset: 0 }"
                    :lg="{ size: 9, offset: 1 }"
                    class="d-flex flex-column h-100 justify-content-between"
                  >
                    <Logo :imgSRC="logo" class="mt-5" @click="() => $router.push({ name: 'Login' })" clicable />
                    <router-view></router-view>
                    <div>
                      <p class="text-muted my-5" v-if="$route.name == 'ConfirmRegister'">
                        If you need help please contact us.<br />
                        <a href="tel:351213405290" class="text-primary">+351 213 405 290</a>
                      </p>
                      <ul class="list-unstyled list-inline mt-3">
                        <li class="list-inline-item">
                          <span class="text-muted font-smaller" v-c-emit-root-event:chooseLang="'en-US'">
                            ©Copyright {{ new Date().getFullYear() }}. SendIt
                          </span>
                        </li>
                        <!--<li class="list-inline-item">
                          <span class="text-muted font-smaller">{{ $t('general.footer.choose-language') }}</span>
                        </li>-->
                        <li class="list-inline-item">
                          <span
                            :class="{ currentLang: currentLang == 'en-US' }"
                            class="span-hover text-muted font-smaller"
                            v-c-emit-root-event:chooseLang="'en-US'"
                            >{{ $t('general.footer.english') }}</span
                          >
                        </li>
                        <li class="list-inline-item">
                          <span
                            :class="{ currentLang: currentLang == 'pt-PT' }"
                            class="span-hover text-muted font-smaller"
                            v-c-emit-root-event:chooseLang="'pt-PT'"
                            >{{ $t('general.footer.portuguese') }}</span
                          >
                        </li>
                        <li class="list-inline-item login-terms">
                          <CLink class="" :to="{ name: 'terms-and-conditions-login' }">
                            {{ $t('general.footer.terms-conditions') }}
                          </CLink>
                        </li>
                        <li class="list-inline-item login-policy">
                          <CLink class="" :to="{ name: 'privacy-policy-login' }">
                            {{ $t('general.footer.privacy-policy') }}
                          </CLink>
                        </li>
                      </ul>
                    </div>
                  </CCol>
                </CRow>
              </CCol>
              <CCol
                v-if="currentRouteName != 'terms-and-conditions-login' && currentRouteName != 'privacy-policy-login'"
                md="12"
                lg="5"
                xl="7"
                class="bannerLogin min-vh-100"
              >
                <CRow
                  class="h-100 d-flex flex-column justify-content-center align-content-center background-right-img"
                  :style="`background-image: url(${backgroundRightImg});`"
                >
                  <CCol sm="12" md="6">
                    <CRow>
                      <component :is="stepRoute"></component>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </transition>
        </CContainer>
      </main>
    </CWrapper>
  </div>
</template>

<script>
import Logo from '@/views/auth/components/logo.vue'
import Login from '@/views/auth/components/aside/RequestDemo'
import NewRegister from '@/views/auth/components/aside/NewRegister'
import BusinessProfile from '@/views/auth/components/aside/CompanyRegister'
import ConfirmRegister from '@/views/auth/components/aside/ConfirmRegister'
import ConfirmRegisterInvite from '@/views/auth/components/aside/ConfirmRegisterInvite'
import { getItem } from '../utils/StorageManager'

export default {
  name: 'TheAuthContainer',
  components: {
    Logo,
  },

  // mounted() {
  //   if (getItem('accessToken')) {
  //     this.$router.replace({ name: 'OrganizationSelection' })
  //   }
  // },

  computed: {
    stepRoute() {
      const components = {
        Login,
        BusinessProfile,
        ConfirmRegister,
        NewRegister,
        ConfirmRegisterInvite,
      }
      return components[this.$route.name]
    },
    currentRouteName() {
      return this.$route.name
    },
    currentLang() {
      return this.$store.state.lang
    },
  },

  data() {
    return {
      backgroundRightImg: require('@/assets/imgs/bg-login-new.png'),
      logo: undefined,
    }
  },

  created() {
    if (this.$store.state.whitelabel.whitelabelConfig) {
      this.backgroundRightImg = this.$store.state.whitelabel.whitelabelConfig.loginScreenImageUrl || require('@/assets/imgs/bg-login-new.png')
      this.logo = this.$store.state.whitelabel.whitelabelConfig.logoUrl || undefined
    }
  },

  mounted() {
    if (getItem('accessToken')) {
      const user = JSON.parse(getItem('user'))
      this.$store.commit('auth/AUTH_SUCESS', { user })
      this.$router.replace({ name: 'OrganizationSelection' })
    }
  },
}
</script>

<style lang="scss">
.background-right-img {
  background-repeat: no-repeat;
  background-size: cover;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.bannerLogin {
  @media only screen and (max-width: 1024px) {
    display: none;
  }
}

.span-hover:hover {
  cursor: pointer;
}

.login-terms a {
  color: #888888;
  margin-left: 50px;
  text-decoration: underline;
}

.login-policy a {
  color: #888888;
  text-decoration: underline;
}

.currentLang {
  color: #8b65b3 !important;
}
</style>
